export default __webpack_public_path__ + "SoluceThirdPics.83f2e40.png";